module.exports = __webpack_public_path__ + "img/64.5.COD.1ffbdac6.png";